import LoadingBar from 'components/loading-bar';
import {
  FunctionComponent,
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';

export const LoadingContext = createContext<{
  loading: boolean | string;
  setLoading: (val: boolean) => void;
}>({} as any);
export const useLoading = () => useContext(LoadingContext);

interface LoadingProviderProps extends PropsWithChildren {}

const LoadingProvider: FunctionComponent<LoadingProviderProps> = ({
  children,
}) => {
  const [loading, setLoading] = useState<boolean | string>(false);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {!loading ? null : <LoadingBar />}
      {children}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;
